import { render, staticRenderFns } from "./BlockResultComponent.vue?vue&type=template&id=335cb47f&scoped=true"
import script from "./BlockResultComponent.vue?vue&type=script&lang=js"
export * from "./BlockResultComponent.vue?vue&type=script&lang=js"
import style0 from "./BlockResultComponent.vue?vue&type=style&index=0&id=335cb47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335cb47f",
  null
  
)

export default component.exports